import { render } from "./LicenseResourceTable.vue?vue&type=template&id=5bb43e2c&ts=true"
import script from "./LicenseResourceTable.vue?vue&type=script&lang=ts"
export * from "./LicenseResourceTable.vue?vue&type=script&lang=ts"

import "./LicenseResourceTable.vue?vue&type=style&index=0&id=5bb43e2c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__